import React from 'react';
import { NavLink } from 'react-router-dom';

const isExternalUrl = (url: string) => /^https?:\/\//.test(url);

interface IProps {
  link: string;
  children: React.ReactNode;
  className: string;
}

export const Link = ({ link, children, ...rest }: IProps) => {
  return isExternalUrl(link) ? (
    <a href={link} target='_blank' rel='noopener noreferrer' {...rest}>
      {children}
    </a>
  ) : (
    <NavLink to={link} {...rest}>
      {children}
    </NavLink>
  );
};
